__turbopack_context__.v({
  "closeButton": "PartnerDiscountModal-module__NITp4G__closeButton",
  "conditionText": "PartnerDiscountModal-module__NITp4G__conditionText",
  "container": "PartnerDiscountModal-module__NITp4G__container",
  "dimmed": "PartnerDiscountModal-module__NITp4G__dimmed",
  "dimmedBackground": "PartnerDiscountModal-module__NITp4G__dimmedBackground",
  "discountComponent": "PartnerDiscountModal-module__NITp4G__discountComponent",
  "discountHeader": "PartnerDiscountModal-module__NITp4G__discountHeader",
  "discountLogo": "PartnerDiscountModal-module__NITp4G__discountLogo",
  "doneButton": "PartnerDiscountModal-module__NITp4G__doneButton",
  "heroSection": "PartnerDiscountModal-module__NITp4G__heroSection",
  "howToClaim": "PartnerDiscountModal-module__NITp4G__howToClaim",
  "imageContainer": "PartnerDiscountModal-module__NITp4G__imageContainer",
  "message": "PartnerDiscountModal-module__NITp4G__message",
  "noAccessBackground": "PartnerDiscountModal-module__NITp4G__noAccessBackground",
  "padlock": "PartnerDiscountModal-module__NITp4G__padlock",
  "promoCode": "PartnerDiscountModal-module__NITp4G__promoCode",
  "rightDiscountHeader": "PartnerDiscountModal-module__NITp4G__rightDiscountHeader",
  "subscribeToUnlock": "PartnerDiscountModal-module__NITp4G__subscribeToUnlock",
});
